<div id="logout" class="transparent">
  <!-- <div id="logout" (click)="showPopup()" class="transparent"> -->
  <span> 
    <a title="{{'ticket' | i18n}}" class="footerTextColor">
      <i class="fas fa-ticket"  style="font-size: 20x;"></i>
      <span id="logout_text" style="font-size: 14px;padding-left: 10px;">{{'ticket' | i18n}}</span>
    </a>
  </span>
</div>
<div id="ticketPopup" class="custom-scroll " [saJquiDialog]="ticketOptions ">
    <div class="row mx-0 service_modal ticket_modal ">
        <div class="modal-content col-xs-12 ">
            <div class="modal-body modalBody">
              
            <!-- <div class="row w-100 text-right">
                <footer class="w-100">
                    <button class="btn btn-danger margin-right-8 search-btn mr-4" title="{{'common_cancel' | i18n}}"
                        >{{'common_cancel' | i18n}}</button>
                    <button type="submit" class="btn btn-primary search-btn" 
                        title="{{'common_submit' | i18n}}">{{'common_submit' | i18n}}</button>
                </footer>
            </div> -->
            <div class="row comingItem">
              <button  type="button" value="Coming Soon" class="sub-btn px-lg-4 borderColor fillGreen "> {{'common_comingsoon'|i18n}}</button>
              </div> 
                <form class="stepsinout-form formly disabledDiv" [formGroup]="ticketForm" novalidate>
                    <formly-form [model]="model" [fields]="ticketFields" [options]="options"
                        [form]="ticketForm">
                    </formly-form>
                    <div class="clearfix"></div>
                    <hr>
                    
                </form>
                
                <div class="row disabledDiv">
                    <section class="col col-12 editor">
                      <label class="control-label heading descriptionLabel"> {{'ticket_description' | i18n}}
                        <!-- <i class="right"> {{'ticket_description_msg'|i18n}}</i> -->
                        <span class="NextconfirmLabels pull-right">
                          <i class="fa fa-exclamation" aria-hidden="true"></i> 
                          {{'ticket_description_msg'|i18n}}
                        </span>
                      </label>
                      <sa-widget [colorbutton]="false" [togglebutton]="false" [collapsed]="false"
                                  [deletebutton]="false" [fullscreenbutton]="false" [editbutton]="false"
                                  [sortable]="false">
                        <div class="summernoteEditor editor">
                          <div class="widget-body no-padding summernoteEditor1">
                            <div class="summernote" id="summernote" [summernote]="{height: 180}">
                            </div>
                            <div class="widget-footer smart-form">
                            </div>
                          </div>
                        </div>
                      </sa-widget>
                      <label class="modalErrorMsg">
                        <i>{{errorMessage | i18n}}</i>
                      </label>
                    </section>
                  </div>
                <div class="col-sm-12 text-left p-0 disabledDiv">
                    <footer class="">
                        <button type="button" (click)="cancel()" class="btn btn-primary mr-3 search-btn font-size-16 cancelButton"
                            title="{{'common_cancel' | i18n}}">{{'common_cancel' | i18n}}</button>
                        <button type="submit" class="btn btn-primary submit-button font-size-16 pull-right"
                            [disabled]="!ticketForm.valid"
                            title="{{'common_ticket_submit' | i18n}}" (click)="submit()">{{'common_ticket_submit' | i18n}}</button>
                    </footer>
                </div>
                
            </div>
        </div>
    </div>
</div>